import React from 'react';
export const CFIconMenu2 = {
    alias: 'menu-2',
    defaultTitle: 'Menu',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M3.935 6h16.129c.515 0 .936.421.936.936v.128a.938.938 0 0 1-.936.936H3.935A.938.938 0 0 1 3 7.064v-.128C3 6.421 3.42 6 3.935 6ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.935-1h12.129c.515 0 .936.421.936.936v.128a.938.938 0 0 1-.936.936H7.935A.938.938 0 0 1 7 12.064v-.128c0-.515.42-.936.935-.936Zm12.129 5H3.935a.938.938 0 0 0-.935.936v.128c0 .515.42.936.935.936h16.129a.938.938 0 0 0 .936-.936v-.128a.938.938 0 0 0-.936-.936Z' }))),
};
